<template>
<FormRow class="designation" inline>
  <FormSelect field="applications.0.campaign">
    <option selected="selected" value="General Donation">General Donation</option>
    <option value="Purim Donation">Purim Donation</option>
    <option value="Alumni Society">Alumni Society</option>
    <option value="Manny Gold">Manny Gold  A'H Fund</option>
    <option value="Torah Fund">Torah Fund</option>
    <option value="Scholarships">Scholarship Funds</option>
    <option value="Post HS Israel">Post High School Israel Scholarship Fund</option>
    <option value="Banquet">Banquet Pledge</option>
    <option value="Tammy Kaplan">Tammy Kaplan A'H Scholarship Fund</option>
    <option value="Margulis Scholarship Fund">Emanuel and Anita Margulis Scholarship Fund</option>    
  </FormSelect>
  <ErrorLabel field="applications.0.campaign" style="text-align:right"/>
</FormRow>
</template>
<script lang="ts">
import {
  defineComponent,
  watch
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  setup() {
    const { getValue } = usePaymentForm()

    return {
      getValue,
    }
  },
})
</script>
<style scoped lang="scss">
.designation {
  display: flex;
  width: 100%;
  position: relative;
  ::v-deep select {
    flex: 1;
    min-width:50%;
    max-width:50%;
    margin-right: 1%;
  }
  ::v-deep select:last-child {
    margin-right: 0;
  }
}
</style>